import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import KeycloakService from './utils/KeycloakService.ts'
import './index.css'
import App from './App.tsx'

// Global error handler for chunk loading errors
window.addEventListener('error', (event) => {
  // Check if it's a chunk loading error
  if (
    event.message?.includes('Failed to fetch') ||
    event.message?.includes('dynamically imported module')
  ) {
    console.error('Chunk loading error detected:', event.message)
    // Optionally show a user-friendly message or reload
    // Uncomment below to auto-reload on chunk errors
    // window.location.reload()
  }
})

// Handle unhandled promise rejections (e.g., from dynamic imports)
window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason?.message?.includes('Failed to fetch') ||
    event.reason?.message?.includes('dynamically imported module')
  ) {
    console.error('Unhandled chunk loading rejection:', event.reason)
    event.preventDefault() // Prevent default error handling
  }
})

const container = document.getElementById('root')
const root = createRoot(container as HTMLElement)

const renderRoot = () => {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  )
}
KeycloakService.initKeycloak(renderRoot)

// import { StrictMode } from 'react'
// import { createRoot } from 'react-dom/client'
// import './index.css'
// import App from './App.tsx'

// createRoot(document.getElementById('root')!).render(
//   <StrictMode>
//     <App />
//   </StrictMode>
// )
